import { useEffect } from 'react';
import { useReduxState } from 'hooks';
import api from 'api';
import { useFormState } from 'informed';
import { Alert } from 'components/common';
import { Select } from '.';

const GroupsSelector = () => {
  const { messages } = useReduxState();

  const formState = useFormState();

  useEffect(() => {
    return () => clearTimeout(getGroupsTimeout);
  }, []);

  let getGroupsTimeout: NodeJS.Timeout;
  const getGroups = (value: string) => {
    clearTimeout(getGroupsTimeout);

    return new Promise((resolve) => {
      getGroupsTimeout = setTimeout(async () => {
        try {
          const response = await api.get(
            `/admin/groups-available?search=${value}`
          );
          const groups =
            response.data?.groups?.map((group) => ({
              label: group.title,
              value: group.id
            })) || [];

          resolve(groups);
        } catch (err) {
          resolve([]);
        }
      }, 500);
    });
  };

  const validate = (value: number[]) => {
    if (!value?.length) return messages.commonFieldRequired;
    else return undefined;
  };

  return (
    <>
      <Select
        async={true}
        error={formState.errors.groupIds}
        id="selector-groupIds"
        field="groupIds"
        isClearable={true}
        isMulti={true}
        isSearchable={true}
        loadingMessage={messages.settingsSearching}
        loadOptions={getGroups}
        noOptionsMessage={messages.groupsEmpty}
        placeholder={messages.groupsSearch}
        showLabelForSelectedElement={true}
        validate={validate}
        validateOnChange={true}
      />

      <Alert style={{ marginTop: 10 }} text={messages.groupsSnapshotWarning} />
    </>
  );
};

export default GroupsSelector;
